import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons'

import { ErrorMessage } from './styled'

interface FormErrorMessageProps {
  message?: React.ReactNode
}

export const FormErrorMessage: React.FC<FormErrorMessageProps> = ({
  message,
}) => {
  if (!message) return null

  return (
    <ErrorMessage className="errorField">
      <FontAwesomeIcon icon={faCircleXmark} />
      <span>{message}</span>
    </ErrorMessage>
  )
}

export default FormErrorMessage
